import React, { useContext } from 'react'
import {
    Switch,
    Route,
    Redirect,
    useLocation
} from "react-router-dom";
import { Web } from '../pages/Web'
import { PantallaCarga } from '../pages/AuthorizeWs02IS/Authorization';

export function PublicRoutes() {
    return (
        <>
            <Switch>             
                <Route exact path='/' component={Web} />  
                <Route exact path='/Login' component={Web} />  
                <Route exact path='/PantallaCarga' component ={PantallaCarga}/>
            </Switch>
        </>
    )
}